import React from "react";
import cx from "classnames";
import { Trans } from "@elevio/kb-kit/lib/components/trans";
import LoginLogout from "./LoginLogout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
const CONTACT_US_URL = 'https://www.cityofmaryesther.com/Directory.aspx';
function Footer({ className }) {
    return (<footer className={cx("footer", className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          <a className="footer-link" target="_blank" href={CONTACT_US_URL}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" role="img" href="https://www.facebook.com/CityOfMaryEstherFlorida" aria-label="facebook-link">
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
